// ===============================|| Blank Layout ||=============================== //
<script setup lang="ts">
import MasterLayout from "~/layouts/master.vue";
</script>
<template>
  <MasterLayout>
    <v-app>
      <NuxtPage />
    </v-app>
  </MasterLayout>
</template>
